import type { ReactNode } from 'react';

export type StatusTone =
  | 'neutral'
  | 'info'
  | 'success'
  | 'warning'
  | 'danger'
  | 'active'
  | 'queued'
  | 'running'
  | 'ready'
  | 'failed'
  | 'stale'
  | 'complete'
  | 'archived';

const TONE_LABEL: Partial<Record<StatusTone, string>> = {
  queued: 'Queued',
  running: 'Running',
  ready: 'Ready',
  failed: 'Failed',
  stale: 'Stale',
  complete: 'Complete',
  active: 'Active',
  archived: 'Archived',
};

interface StatusBadgeProps {
  tone?: StatusTone;
  children?: ReactNode;
  title?: string;
}

export function StatusBadge({ tone = 'neutral', children, title }: StatusBadgeProps) {
  const label = children ?? TONE_LABEL[tone] ?? tone;
  return (
    <span className={`status-badge status-badge--${tone}`} title={title} data-testid="status-badge">
      <span className="status-badge__mark" aria-hidden="true" />
      <span className="status-badge__label">{label}</span>
    </span>
  );
}
